import React from 'react';

import clsx from 'clsx';

import type { BaseComponentProps } from '@coursera/cds-common';

import getContentCss, { classes } from './styles/getContentCss';

export type Props = BaseComponentProps<'div'> & {
  /**
   * Whether to add padding to the content.
   * @default true
   */
  contentPadding?: boolean;
};

const Content = React.forwardRef(function Content(
  props: Props,
  ref: React.Ref<HTMLDivElement>
) {
  const { children, contentPadding = true, ...rest } = props;

  return (
    <div
      ref={ref}
      className={clsx({
        [classes.notPadded]: !contentPadding,
      })}
      css={getContentCss}
      {...rest}
    >
      {children}
    </div>
  );
});

if (__DEV__) {
  Content.displayName = 'TemporaryDrawer.Content';
}

export default Content;
